export const PRICING_CATEGORY_TYPE = {
  SCHOOL_AND_ACADEMICS: 'SCHOOL_AND_ACADEMICS',
  TEAM_SPORTS_WITH_NUMBERED_JERSEY: 'TEAM_SPORTS_WITH_NUMBERED_JERSEY',
  RACING: 'RACING',
  PERFORMANCE_AND_COMPETITION: 'PERFORMANCE_AND_COMPETITION',
  OTHER: 'OTHER',
};

export const PRICING_CATEGORY_TYPE_LABELS = {
  [PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS]:
    'SCHOOL & ACADEMIC (FACIAL RECOGNITION)',
  [PRICING_CATEGORY_TYPE.TEAM_SPORTS_WITH_NUMBERED_JERSEY]:
    'TEAM SPORTS (FACIAL AND/OR NUMBERED JERSEY RECOGNITION)',
  [PRICING_CATEGORY_TYPE.RACING]: 'RACING (BIB & PLATE NUMBER RECOGNITION)',
  [PRICING_CATEGORY_TYPE.PERFORMANCE_AND_COMPETITION]:
    'PERFORMANCE & COMPETITION (FACIAL REC AND/OR TIME-BASED MATCHING)',
  [PRICING_CATEGORY_TYPE.OTHER]: 'OTHER SPORTS',
};

// Portrait-only galleries show a trimmed, re-grouped category list: the
// facial / jersey recognition qualifiers go away and the team sports group
// becomes "Team & Individual Portraits".
export const PORTRAIT_PRICING_CATEGORY_TYPE_LABELS = {
  ...PRICING_CATEGORY_TYPE_LABELS,
  [PRICING_CATEGORY_TYPE.SCHOOL_AND_ACADEMICS]: 'SCHOOL & ACADEMIC',
  [PRICING_CATEGORY_TYPE.TEAM_SPORTS_WITH_NUMBERED_JERSEY]:
    'TEAM & INDIVIDUAL PORTRAITS',
};

// Categories offered as plain portrait categories under "Team & Individual
// Portraits" for portrait shoots, wherever they live for action shoots
// (Racing, Performance & Competition, Other). Matched by exact name, so a
// category added later must use one of these names to land in that group.
export const PORTRAIT_INDIVIDUAL_CATEGORY_NAMES = [
  'Track & Field',
  'Cross Country',
  'Dance',
  'Pageants',
  'Gymnastics',
  'Wrestling',
  'Cheer / Pom',
  'Swimming',
  'Band',
  'Badminton',
  'Water Polo',
];

// Only commencements are shot as action photography in the School & Academic
// group; the two school portrait categories are portrait only.
export const ACTION_SCHOOL_CATEGORY_NAMES = ['Commencements'];
